import React from 'react';

import { Body as BodyText } from 'js/design_system/Body';
import { Button } from 'js/design_system/Button';
import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';
import { ImpressionEntity } from 'js/utils/impressions/watchImpressions';
import { WorkId } from 'js/liswp/types';

import {
  Footer,
  NoThanksButton,
  PrimaryButtonWrap,
} from './StatelessWorkCardsUpsellModal.styles';

export interface ModalFooterProps {
  isPremium: boolean;
  hideSecondaryAction: boolean;
  onSecondaryAction?: () => void;
  onClose: () => void;
  secondaryActionLabel?: string;
  onPrimaryCtaClicked: () => void;
  primaryCtaLabel: string;
  primaryCtaImpressionSource: string;
  sourceWorkId: WorkId;
  modalVariant: string;
  transactionalPricingBucket?: string;
}

export function ModalFooter({
  isPremium,
  hideSecondaryAction,
  onSecondaryAction,
  onClose,
  secondaryActionLabel,
  onPrimaryCtaClicked,
  primaryCtaLabel,
  primaryCtaImpressionSource,
  sourceWorkId,
  modalVariant,
  transactionalPricingBucket,
}: ModalFooterProps) {
  return (
    <Footer className={isPremium ? 'premium' : undefined}>
      {!hideSecondaryAction && (
        <NoThanksButton type="button" onClick={onSecondaryAction ?? onClose}>
          <BodyText size="md" as="span">
            {secondaryActionLabel ?? "No thanks, I'll stay on the free tier"}
          </BodyText>
        </NoThanksButton>
      )}
      <ImpressionWatcher
        source={primaryCtaImpressionSource}
        entity_type={ImpressionEntity.Work}
        entity_id={sourceWorkId}
        extra={{
          modalVariant,
          is_premium: isPremium,
          ...(transactionalPricingBucket !== undefined && {
            transactional_pricing_bucket: transactionalPricingBucket,
          }),
        }}
      >
        <PrimaryButtonWrap>
          <Button
            size="lg"
            iconRight={isPremium ? 'download' : 'arrow_forward'}
            fullWidth
            onClick={onPrimaryCtaClicked}
          >
            {primaryCtaLabel}
          </Button>
        </PrimaryButtonWrap>
      </ImpressionWatcher>
    </Footer>
  );
}

export default ModalFooter;
